import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getListArriveLateManagerStart,
  getListArriveLateManagerSuccess,
  getListArriveLateManagerFailed,
} from "../redux/getListArriveLateManager";
import { getListArriveLateManagerAPI } from "core/http/service/decleareLeave";
import moment from "moment";

function* getListArriveLateManagerWork(action) {
  const { screenCode, ...payload } = action.payload;
  try {
    const res = yield call(getListArriveLateManagerAPI, {
      screenCode,
      ...payload,
    });
    const formattedData = res.data.map((item, index) => ({
      ...item,
      index: index + 1,
      fromDate: moment(item?.fromDate),
      toDate: moment(item?.toDate),
    }));
    yield put({
      type: getListArriveLateManagerSuccess.type,
      payload: formattedData,
    });
  } catch (error: any) {
    yield put({
      type: getListArriveLateManagerFailed.type,
    });
  }
}

function* watchGetListArriveLateManager() {
  yield takeLatest(
    getListArriveLateManagerStart.type,
    getListArriveLateManagerWork
  );
}

export default function* getListArriveLateManagerSaga() {
  yield all([watchGetListArriveLateManager()]);
}
